module.exports = __webpack_public_path__ + "static/media/Involved2.13363e03.svg";